export const EXCLUDED_COUNTRIES = [
  "CI", "NG", "GH", "SN", "BF", "ML", "TG", "BJ", "NE", "CD", "CG", "CM", "KE", "UG", "TZ", "RW", "ZW", "ZM", "MW", "SO", "ET", "SD", "LY", "DZ", "IQ", "AF", "PK", "BD", "LK", "MM", "NP", "IR", "SY", "YE", "VE", "CU", "HT", "PR"
]